// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/semantic-ui-css/semantic.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/svg/checked.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Icon/background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/Icon/Home_bg6.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets//Icon/ActiveGoals2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/Icon/InactiveGoals2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../src/assets/Icon/turtlemintSectionBg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url(../../node_modules/semantic-ui-css/semantic.min.css); */
/* ! tailwindcss v3.3.5 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/
html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
html {
    font-family: "DM Sans", sans-serif !important;
    font-feature-settings: "kern" !important;
    -webkit-font-smoothing: antialiased;
    letter-spacing: -0.5px;
  }
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container{
  width: 100%;
  padding-right: 1rem;
  padding-left: 1rem;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1200px){
  .container{
    max-width: 1200px;
  }
}
@media (min-width: 1390px){
  .container{
    max-width: 1390px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.invisible{
  visibility: hidden;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.-bottom-12{
  bottom: -3rem;
}
.-start-\\[180px\\]{
  inset-inline-start: -180px;
}
.-start-\\[230px\\]{
  inset-inline-start: -230px;
}
.-start-\\[250px\\]{
  inset-inline-start: -250px;
}
.-top-12{
  top: -3rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-\\[30px\\]{
  bottom: 30px;
}
.end-0{
  inset-inline-end: 0px;
}
.end-4{
  inset-inline-end: 1rem;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-3{
  left: 0.75rem;
}
.right-0{
  right: 0px;
}
.right-10{
  right: 2.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-\\[35px\\]{
  right: 35px;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-11{
  top: 2.75rem;
}
.top-20{
  top: 5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-40{
  top: 10rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[15\\%\\]{
  top: 15%;
}
.top-px{
  top: 1px;
}
.\\!z-50{
  z-index: 50 !important;
}
.\\!z-\\[99\\]{
  z-index: 99 !important;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[5\\]{
  z-index: 5;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.float-left{
  float: left;
}
.m-5{
  margin: 1.25rem;
}
.m-\\[auto\\]{
  margin: auto;
}
.m-auto{
  margin: auto;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-\\[56px\\]{
  margin-left: 56px;
  margin-right: 56px;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-\\[12px\\]{
  margin-top: 12px;
  margin-bottom: 12px;
}
.my-\\[3px\\]{
  margin-top: 3px;
  margin-bottom: 3px;
}
.-ml-\\[1\\.5rem\\]{
  margin-left: -1.5rem;
}
.-mr-3{
  margin-right: -0.75rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-40{
  margin-bottom: 10rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-auto{
  margin-bottom: auto;
}
.mb-px{
  margin-bottom: 1px;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-\\[18px\\]{
  margin-left: 18px;
}
.ml-\\[22px\\]{
  margin-left: 22px;
}
.ml-\\[6px\\]{
  margin-left: 6px;
}
.ml-\\[750px\\]{
  margin-left: 750px;
}
.ml-auto{
  margin-left: auto;
}
.ml-px{
  margin-left: 1px;
}
.mr-10{
  margin-right: 2.5rem;
}
.mr-12{
  margin-right: 3rem;
}
.mr-20{
  margin-right: 5rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-\\[6px\\]{
  margin-right: 6px;
}
.ms-1{
  margin-inline-start: 0.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.ms-4{
  margin-inline-start: 1rem;
}
.ms-\\[6px\\]{
  margin-inline-start: 6px;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-28{
  margin-top: 7rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[100px\\]{
  margin-top: 100px;
}
.mt-\\[10px\\]{
  margin-top: 10px;
}
.mt-\\[12px\\]{
  margin-top: 12px;
}
.mt-\\[15px\\]{
  margin-top: 15px;
}
.mt-\\[20px\\]{
  margin-top: 20px;
}
.mt-\\[22px\\]{
  margin-top: 22px;
}
.mt-\\[25px\\]{
  margin-top: 25px;
}
.mt-\\[3px\\]{
  margin-top: 3px;
}
.mt-\\[50px\\]{
  margin-top: 50px;
}
.mt-\\[58px\\]{
  margin-top: 58px;
}
.mt-\\[5px\\]{
  margin-top: 5px;
}
.mt-px{
  margin-top: 1px;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[1\\.125rem\\]{
  height: 1.125rem;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[15px\\]{
  height: 15px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[210px\\]{
  height: 210px;
}
.h-\\[216px\\]{
  height: 216px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[4rem\\]{
  height: 4rem;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[565px\\]{
  height: 565px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[61px\\]{
  height: 61px;
}
.h-\\[800px\\]{
  height: 800px;
}
.h-\\[80px\\]{
  height: 80px;
}
.h-\\[83px\\]{
  height: 83px;
}
.h-\\[87px\\]{
  height: 87px;
}
.h-\\[90px\\]{
  height: 90px;
}
.h-\\[auto\\]{
  height: auto;
}
.h-fit{
  height: -moz-fit-content;
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.min-h-\\[1\\.5rem\\]{
  min-height: 1.5rem;
}
.min-h-\\[20px\\]{
  min-height: 20px;
}
.min-h-\\[84vh\\]{
  min-height: 84vh;
}
.min-h-\\[auto\\]{
  min-height: auto;
}
.min-h-full{
  min-height: 100%;
}
.w-1{
  width: 0.25rem;
}
.w-1\\/2{
  width: 50%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-24{
  width: 6rem;
}
.w-4{
  width: 1rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[1\\.125rem\\]{
  width: 1.125rem;
}
.w-\\[10\\%\\]{
  width: 10%;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[108px\\]{
  width: 108px;
}
.w-\\[15px\\]{
  width: 15px;
}
.w-\\[180\\]{
  width: 180;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[224px\\]{
  width: 224px;
}
.w-\\[256px\\]{
  width: 256px;
}
.w-\\[30px\\]{
  width: 30px;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[355px\\]{
  width: 355px;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[450px\\]{
  width: 450px;
}
.w-\\[50\\%\\]{
  width: 50%;
}
.w-\\[50px\\]{
  width: 50px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[611px\\]{
  width: 611px;
}
.w-\\[664px\\]{
  width: 664px;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[700px\\]{
  width: 700px;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[83px\\]{
  width: 83px;
}
.w-\\[85px\\]{
  width: 85px;
}
.w-\\[87px\\]{
  width: 87px;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[auto\\]{
  width: auto;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-screen-sm{
  max-width: 640px;
}
.max-w-screen-xl{
  max-width: 1280px;
}
.flex-none{
  flex: none;
}
.shrink{
  flex-shrink: 1;
}
.flex-grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-auto{
  flex-basis: auto;
}
.origin-\\[0_0\\]{
  transform-origin: 0 0;
}
.origin-\\[65\\%_0\\%\\]{
  transform-origin: 65% 0%;
}
.origin-\\[75\\%_0\\%\\]{
  transform-origin: 75% 0%;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-96{
  --tw-translate-x: -24rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0{
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75{
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize{
  resize: both;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.\\!flex-row{
  flex-direction: row !important;
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.\\!justify-between{
  justify-content: space-between !important;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-1{
  gap: 0.25rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-\\[5px\\]{
  gap: 5px;
}
.space-x-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2.5rem * var(--tw-space-x-reverse));
  margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-7 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.75rem * var(--tw-space-x-reverse));
  margin-left: calc(1.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.self-center{
  align-self: center;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overflow-x-scroll{
  overflow-x: scroll;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[0\\.25rem\\]{
  border-radius: 0.25rem;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-bl-none{
  border-bottom-left-radius: 0px;
}
.rounded-br-lg{
  border-bottom-right-radius: 0.5rem;
}
.rounded-tl-none{
  border-top-left-radius: 0px;
}
.rounded-tr-lg{
  border-top-right-radius: 0.5rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-\\[0\\.125rem\\]{
  border-width: 0.125rem;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-\\[4px\\]{
  border-width: 4px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-none{
  border-style: none !important;
}
.border-none{
  border-style: none;
}
.\\!border-gray-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;
}
.\\!border-green-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(34 197 94 / var(--tw-border-opacity)) !important;
}
.\\!border-red-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#00A465\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 164 101 / var(--tw-border-opacity));
}
.border-\\[\\#6a53ff\\]{
  --tw-border-opacity: 1;
  border-color: rgb(106 83 255 / var(--tw-border-opacity));
}
.border-\\[\\#E5E7E8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 232 / var(--tw-border-opacity));
}
.border-\\[\\#d6d9e6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(214 217 230 / var(--tw-border-opacity));
}
.border-\\[\\#ed3548\\]{
  --tw-border-opacity: 1;
  border-color: rgb(237 53 72 / var(--tw-border-opacity));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
.border-neutral-300{
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-yellow-600{
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity));
}
.\\!bg-gray-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#00A465\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 164 101 / var(--tw-bg-opacity));
}
.bg-\\[\\#02295a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(2 41 90 / var(--tw-bg-opacity));
}
.bg-\\[\\#0b14374d\\]{
  background-color: #0b14374d;
}
.bg-\\[\\#14AE5C\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(20 174 92 / var(--tw-bg-opacity));
}
.bg-\\[\\#3970de\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(57 112 222 / var(--tw-bg-opacity));
}
.bg-\\[\\#473dff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(71 61 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#6AD2FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(106 210 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#E0E5F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(224 229 242 / var(--tw-bg-opacity));
}
.bg-\\[\\#d6d9e6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(214 217 230 / var(--tw-bg-opacity));
}
.bg-\\[\\#e0e5f2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(224 229 242 / var(--tw-bg-opacity));
}
.bg-\\[\\#f0f6ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#fafbff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 251 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#fff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}
.bg-lime-500{
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.bg-pink-400{
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity));
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity));
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/0{
  background-color: rgb(255 255 255 / 0);
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-none{
  background-image: none;
}
.from-\\[\\#868CFF\\]{
  --tw-gradient-from: #868CFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(134 140 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-500{
  --tw-gradient-from: #14b8a6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/50{
  --tw-gradient-from: rgb(255 255 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#432CF3\\]{
  --tw-gradient-to: rgb(67 44 243 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #432CF3 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-500{
  --tw-gradient-to: rgb(59 130 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #3b82f6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-indigo-500{
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-white\\/10{
  --tw-gradient-to: rgb(255 255 255 / 0.1) var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-clip-border{
  background-clip: border-box;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.object-cover{
  object-fit: cover;
}
.\\!p-4{
  padding: 1rem !important;
}
.\\!p-\\[20px\\]{
  padding: 20px !important;
}
.p-0{
  padding: 0px;
}
.p-10{
  padding: 2.5rem;
}
.p-11{
  padding: 2.75rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[10px\\]{
  padding: 10px;
}
.p-\\[11px\\]{
  padding: 11px;
}
.p-\\[14px\\]{
  padding: 14px;
}
.p-\\[15px\\]{
  padding: 15px;
}
.p-\\[16px\\]{
  padding: 16px;
}
.p-\\[20px\\]{
  padding: 20px;
}
.p-\\[26px\\]{
  padding: 26px;
}
.p-\\[40px\\]{
  padding: 40px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-11{
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}
.px-16{
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[0\\.32rem\\]{
  padding-top: 0.32rem;
  padding-bottom: 0.32rem;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[10px\\]{
  padding-bottom: 10px;
}
.pb-\\[130px\\]{
  padding-bottom: 130px;
}
.pb-\\[16px\\]{
  padding-bottom: 16px;
}
.pb-\\[18px\\]{
  padding-bottom: 18px;
}
.pb-\\[195px\\]{
  padding-bottom: 195px;
}
.pb-\\[25px\\]{
  padding-bottom: 25px;
}
.pe-16{
  padding-inline-end: 4rem;
}
.pe-2{
  padding-inline-end: 0.5rem;
}
.pe-28{
  padding-inline-end: 7rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-\\[0\\.15rem\\]{
  padding-left: 0.15rem;
}
.pl-\\[1\\.5rem\\]{
  padding-left: 1.5rem;
}
.pl-\\[20px\\]{
  padding-left: 20px;
}
.pr-14{
  padding-right: 3.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-\\[20px\\]{
  padding-right: 20px;
}
.ps-3{
  padding-inline-start: 0.75rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-\\[0\\.37rem\\]{
  padding-top: 0.37rem;
}
.pt-\\[14px\\]{
  padding-top: 14px;
}
.pt-\\[40px\\]{
  padding-top: 40px;
}
.pt-\\[71px\\]{
  padding-top: 71px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-justify{
  text-align: justify;
}
.text-start{
  text-align: start;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[33px\\]{
  font-size: 33px;
}
.text-\\[34px\\]{
  font-size: 34px;
}
.text-\\[37px\\]{
  font-size: 37px;
}
.text-\\[80px\\]{
  font-size: 80px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.leading-10{
  line-height: 2.5rem;
}
.leading-4{
  line-height: 1rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-9{
  line-height: 2.25rem;
}
.leading-\\[1\\.6\\]{
  line-height: 1.6;
}
.leading-normal{
  line-height: 1.5;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.text-\\[\\#02295a\\]{
  --tw-text-opacity: 1;
  color: rgb(2 41 90 / var(--tw-text-opacity));
}
.text-\\[\\#14AE5C\\]{
  --tw-text-opacity: 1;
  color: rgb(20 174 92 / var(--tw-text-opacity));
}
.text-\\[\\#28648a\\]{
  --tw-text-opacity: 1;
  color: rgb(40 100 138 / var(--tw-text-opacity));
}
.text-\\[\\#473dff\\]{
  --tw-text-opacity: 1;
  color: rgb(71 61 255 / var(--tw-text-opacity));
}
.text-\\[\\#525252\\]{
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity));
}
.text-\\[\\#9699ab\\]{
  --tw-text-opacity: 1;
  color: rgb(150 153 171 / var(--tw-text-opacity));
}
.text-\\[\\#adbeff\\]{
  --tw-text-opacity: 1;
  color: rgb(173 190 255 / var(--tw-text-opacity));
}
.text-\\[\\#ed3548\\]{
  --tw-text-opacity: 1;
  color: rgb(237 53 72 / var(--tw-text-opacity));
}
.text-\\[\\#fff\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.text-neutral-500{
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/0{
  color: rgb(255 255 255 / 0);
}
.underline{
  text-decoration-line: underline;
}
.decoration-solid{
  text-decoration-style: solid;
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_15px_-3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.07\\)\\2c 0_10px_20px_-2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 2px 15px -3px rgba(0,0,0,0.07),0 10px 20px -2px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_9px_-4px_\\#3b71ca\\]{
  --tw-shadow: 0 4px 9px -4px #3b71ca;
  --tw-shadow-colored: 0 4px 9px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-blue-500\\/50{
  --tw-shadow-color: rgb(59 130 246 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-white\\/5{
  --tw-shadow-color: rgb(255 255 255 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\!duration-200{
  transition-duration: 200ms !important;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-\\[0\\.2s\\]{
  transition-duration: 0.2s;
}
.duration-\\[0\\.5s\\]{
  transition-duration: 0.5s;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
  transition-timing-function: linear;
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}



input.defaultCheckbox::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: white;
  opacity: 0;
  height: 16px;
  width: 16px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0px);
}

input:checked.defaultCheckbox::before {
  opacity: 1;
}

.timeContainer {
  z-index: 10;
  display: flex;
  /* border: 1px solid red; */
}

.timeContainer .wrapper {
  width: 100%;
  /* padding: 20px; */

  display: flex;
  justify-content: space-around;
  gap: 10px;
}

.timeContainer .wrapper div {
  /* color: #ccc; */
  text-align: center;
  width: 24%;
  height: 50px;
  border-radius: 12px;
  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16); */
}

.timeContainer .wrapper div:first-child {
  color: #28648a;
}

.timeContainer .wrapper div:nth-child(2) {
  color: #28648a;
}

.timeContainer .wrapper div:nth-child(3) {
  color: #28648a;
}

.timeContainer .wrapper div:nth-child(4) {
  color: #28648a;
}
.timeContainer .wrapper div:nth-child(5) {
  color: #28648a;
}



.timeContainer .wrapper div h2 {
  font-size: 10px;
}

#seconds {
  font-size: 16px;
}

#minutes {
  font-size: 16px;
}
#hours {
  font-size: 16px;
}

.hours_text{
  font-size: 12px;
}

.backgroundLogin {
  background-image: linear-gradient(115deg, #9f7aea, #fee2fe);
  background-size: cover;
}

.backgroundImg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

#header-bar {
  background-color: #dfe1e3 !important;
  display: none;
}
#pdf-page-info {
  display: none;
}
#pdf-download {
  display: none;
}
.ui.inverted.menu {
  background-color: #3970de;
}
a:hover {
  color: #3970de;
  text-decoration: none;
}

@media only screen and (max-width: 640px) and (min-width: 0px) {
  .question {
    font-size: 18px;
  }
  .ui.massive.buttons .button {
    font-size: 18px;
  }

  .ui[class*="right floated"].button,
  .ui[class*="right floated"].buttons {
    float: left;
    margin-right: 0;
    margin-left: 0.25em;
  }

  .ui.items > .item [class*="right floated"] {
    float: left;
  }

  .ui.items > .item .extra > [class*="right floated"] {
    margin: 0;
  }
  .ui.huge.message {
    font-size: 16px;
  }

  .options {
    font-size: 16px;
  }

  .ui.container {
    width: auto !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
}

@media only screen and (max-width: 768px) and (min-width: 640px) {
  .question {
    font-size: 18px;
  }
  .ui.massive.buttons .button {
    font-size: 18px;
  }
  .ui.huge.message {
    font-size: 16px;
  }
  .options {
    font-size: 16px;
  }
}

@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .question {
    font-size: 18px;
  }
  .ui.massive.buttons .button {
    font-size: 18px;
  }
  .ui.huge.message {
    font-size: 16px;
  }
  .options {
    font-size: 16px;
  }
}

@media only screen and (max-width: 1200px) and (min-width: 1024px) {
  .question {
    font-size: 20px;
  }
  .ui.massive.buttons .button {
    font-size: 20px;
  }
  .ui.huge.message {
    font-size: 18px;
  }
  .options {
    font-size: 16px;
  }
}

@media only screen and (max-width: 1536px) and (min-width: 1200px) {
  .question {
    font-size: 22px;
  }
  .ui.massive.buttons .button {
    font-size: 22px;
  }
  .ui.huge.message {
    font-size: 20px;
  }
  .options {
    font-size: 16px;
  }
}

.businessUpdateWrapper {
	/* background-image: url("./assets/Icon/background.png"); */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    no-repeat,
    rgb(250, 250, 250);
  padding: 15px 0px 8px;
  background-size: cover; 

}

.businessUpdateWrapper1 {
	
  padding: 15px 0px 64px;

}



@media (min-width: 768px){
	.fkjiCM {
		max-width: 1400px;
		margin: 0px auto;
	}
	.fkjiCM .businessUpdateWrapper {
		gap: 20px;
	}
}
/* .fkjiCM {
    max-width: 1400px;
    margin: 0px auto;
} */

.fkjiCM .business_update {
	font-family: unset;
    font-style: normal;
    font-weight: 700;
    font-size: 37px;
    line-height: 50px;
    display: flex;
    align-items: center;
    text-align: center;
    max-width: 1200px;
    color: rgb(0, 0, 0);
    margin: 60px auto 30px;
    margin-left: 40px;
}

.ekulFW {
    
	font-family: 'Roboto', sans-serif;
    font-style: normal;
    width: 100%;
    left: 112px;
    top: 206px;
    background: linear-gradient(259.24deg, rgb(241, 226, 204) -10.54%, rgb(251, 236, 237) 97.86%);
    background: linear-gradient(259.24deg, rgb(126 190 234) -10.54%, rgb(217 233 242) 97.86%);

    border-radius: 12px;
}

.ekulFW .titleValue {
    font-weight: 700;
    font-size: 24px;
    line-height: 50px;
    display: flex;
    align-items: center;
    color: rgb(0, 0, 0);
    padding: 0px 0px 5px;
}

.ekulFW .regards {
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    display: flex;
    align-items: center;
    text-transform: capitalize;
    color: rgb(0, 0, 0);
}

.ekulFW .description {
    font-size: 20px;
    font-weight: 400;
    padding: 10px 0px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-width: 84%;
}

.ekulFW .renewals_redirection {
    margin: 10px 0px;
    background: #fff;
	font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 32px;
    align-items: center;
    padding: 8px 20px;
    color: rgb(0, 0, 0);
    border-radius: 12px;
    cursor: pointer;
    width: 157px;
}

.fkjiCM .businessUpdateWrapper {
    display: flex;
    padding: 0px 112px;
}
.ekulFW .upcomingRenewals {
    display: flex;
}
.ekulFW .left_section {
    width: 70%;
    padding: 24px 0px 24px 40px;
}

.ekulFW .right_section {
  display: flex;
  justify-content: start;
  align-items: center;
}



 .goalsWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* padding: 80px 40px 80px; */
    gap: 36px;
	  padding-top: 30px;
}

 .homeHeading {
    width: 908px;
    color: rgb(0, 0, 0);
    font-size: 30px;
    font-weight: 700;
    line-height: 50px;
    text-align: center;
    
}

 .goalsContent {
    display: flex;
    gap: 23px;
}
.cNBNFI.active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center center / cover;
}

.cNBNFI {
    display: flex;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center center / cover;
    padding: 20px 32px;
    width: 390px;
    border-radius: 12px;
}

.cNBNFI .goalDescriptionWrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.cNBNFI .goalDescriptionWrapper .step {
    display: flex;
    color: rgb(18, 22, 23);
    font-size: 14px;
    letter-spacing: 0.28px;
    line-height: 16px;
    padding: 4px 8px;
    border-radius: 23px;
    border: 1px solid rgb(255, 255, 255);
    background: rgba(255, 255, 255, 0.7);
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
    margin-bottom: 11.5px;
}

.cNBNFI .goalDescriptionWrapper .title {
    margin-bottom: 7.5px;
    color: rgb(18, 22, 23);
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.36px;
    line-height: 21px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cNBNFI .goalDescriptionWrapper .description {
    color: rgb(18, 22, 23);
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.28px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cNBNFI .goalDescriptionWrapper .actionWrapper {
    display: flex;
    align-items: flex-start;
    padding: 0px !important;
}

@media (min-width: 768px){
	.actionWrapper {
		flex-direction: row;
	}
}

.cNBNFI .goalDescriptionWrapper .actionWrapper .ctaButton {
    color: #000;

    font-size: 15px;
    font-weight: 700;
    padding: 10px 16px;
    margin-top: 14px;
    border-radius: 24px;
    background: #ffffffb3;

    cursor: pointer;
    line-height: 17.58px;
}

.actionWrapper span {
   
    display: flex;
    flex-direction: row;
}

.cNBNFI {
    display: flex;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center center / cover;
    padding: 20px 32px;
    width: 390px;
    border-radius: 12px;
}

.cNBNFI .goalDescriptionWrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.cNBNFI .goalDescriptionWrapper .step {
    display: flex;
    color: rgb(18, 22, 23);
    font-size: 14px;
    letter-spacing: 0.28px;
    line-height: 16px;
    padding: 4px 8px;
    border-radius: 23px;
    border: 1px solid rgb(255, 255, 255);
    background: rgba(255, 255, 255, 0.7);
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
    margin-bottom: 11.5px;
}

.cNBNFI .goalDescriptionWrapper .title.inactiveTitle {
    color: #000;
    
}
.cNBNFI .goalDescriptionWrapper .title.activeTitle {
  color: #fff;
  
}

.cNBNFI .goalDescriptionWrapper .title {
    margin-bottom: 7.5px;
    color: rgb(18, 22, 23);
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.36px;
    line-height: 21px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cNBNFI .goalDescriptionWrapper .description {
    color: rgb(18, 22, 23);
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.28px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cNBNFI .goalDescriptionWrapper .description.inactiveDescription {
    color: #000;
   
}
.cNBNFI .goalDescriptionWrapper .description.activeDescription {
  color: #fff;
 
}

.cNBNFI .goalDescriptionWrapper .actionWrapper {
    display: flex;
    align-items: flex-start;
    padding: 0px !important;
}

@media (min-width: 768px){
	.actionWrapper {
		flex-direction: row;
	}
}
.cNBNFI .goalDescriptionWrapper .actionWrapper .note {
    color: rgb(255, 62, 1);
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.24px;
    padding-top: 8px;
}
.cNBNFI .iconWrapper {
    display: flex;
    align-items: center;
}

/* .cNBNFI .iconWrapper > img {
    width: 108px;
    height: 108px;
} */
.certi_image{
  width: 88px;
    height: 108px;
}
.kyc_image{
  width: 108px;
  height: 100px;
}
.sell_image{
  width: 108px;
  height: 108px;
}


/* ------------ What can --------- */

.iUAlfZ .turtlemintSectionWrapper {
    display: flex;
    width: 100vw;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    padding: 80px 112px ;

    gap: 34px;
}

@media  (min-width: 768px) {
	.iUAlfZ .turtlemintSectionContainer {
		display: flex;
		max-width: 1400px;
		margin: 0px auto;
	}
	.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionContent > div:nth-child(2n+1) {
		margin-top: 124px;
	}
	.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionContent > div:nth-child(2n) {
		margin-bottom: 124px;
	}
	.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionContent > div:nth-child(2n+1) {
		margin-top: 124px;
	}
}

.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionTitle {
    font-size: 40px;
    font-weight: 400;
    line-height: 70px;
    color: rgb(3, 56, 36);
    width: 314px;
    padding-top: 29px;
}
.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionContent {
    display: flex;
    gap: 32px;
}

.cKgNZQ {
    display: flex;
    flex-direction: column;
    width: 268px;
    height: 288px;
    padding: 24px;
    border-radius: 8px;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(0, 164, 101);
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 16px 0px;
}

.cKgNZQ > img {
    display: flex;
    width: 54px;
    height: 54px;
}

.cKgNZQ .sectionDetailsWrapper {
    display: flex;
    flex-direction: column;
}

.cKgNZQ .sectionDetailsWrapper .title {
    padding: 16px 0px;
    color: rgb(48, 55, 51);
    font-size: 24px;
    font-weight: 700;
    line-height: 14px;
}

.cKgNZQ .sectionDetailsWrapper .description {
    font-size: 14px;
    line-height: 24px;
    color: rgb(96, 96, 96);
}

.cKgNZQ .sectionDetailsWrapper .ctaWrapper {
    display: flex;
    cursor: pointer;
    padding: 40px 0px 0px;
    gap: 16px;
    align-items: center;
}

.cKgNZQ .sectionDetailsWrapper .ctaWrapper .cta {
    color: rgb(0, 134, 115);
    font-size: 17px;
    font-weight: 700;
}

.xineh {
    display: flex;
    flex-direction: column;
    width: 268px;
    height: 288px;
    padding: 24px;
    border-radius: 8px;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(245, 174, 10);
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 16px 0px;
}

.xineh > img {
    display: flex;
    width: 54px;
    height: 54px;
}

.xineh .sectionDetailsWrapper {
    display: flex;
    flex-direction: column;
}

.xineh .sectionDetailsWrapper .title {
    padding: 16px 0px;
    color: rgb(48, 55, 51);
    font-size: 24px;
    font-weight: 700;
    line-height: 14px;
}

.xineh .sectionDetailsWrapper .description {
    font-size: 14px;
    line-height: 24px;
    color: rgb(96, 96, 96);
}

.xineh .sectionDetailsWrapper .ctaWrapper {
    display: flex;
    cursor: pointer;
    padding: 40px 0px 0px;
    gap: 16px;
    align-items: center;
}

.xineh .sectionDetailsWrapper .ctaWrapper .cta {
    color: rgb(245, 174, 10);
    font-size: 17px;
    font-weight: 700;
}

.xineh .sectionDetailsWrapper .ctaWrapper > svg > circle {
    fill: rgb(245, 174, 10);
    stroke: rgb(253, 239, 206);
}

.hkRHto {
    display: flex;
    flex-direction: column;
    width: 268px;
    height: 288px;
    padding: 24px;
    border-radius: 8px;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(171, 37, 108);
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 16px 0px;
}

.hkRHto > img {
    display: flex;
    width: 54px;
    height: 54px;
}
.hkRHto .sectionDetailsWrapper {
    display: flex;
    flex-direction: column;
}

.hkRHto .sectionDetailsWrapper .title {
    padding: 16px 0px;
    color: rgb(48, 55, 51);
    font-size: 24px;
    font-weight: 700;
    line-height: 14px;
}

.hkRHto .sectionDetailsWrapper .description {
    font-size: 14px;
    line-height: 24px;
    color: rgb(96, 96, 96);
}

.hkRHto .sectionDetailsWrapper .ctaWrapper {
    display: flex;
    cursor: pointer;
    padding: 40px 0px 0px;
    gap: 16px;
    align-items: center;
}

.hkRHto .sectionDetailsWrapper .ctaWrapper > svg > circle {
    fill: rgb(171, 37, 108);
    stroke: rgb(239, 201, 220);
}


/* ------- Navbar Icons Color ---------------- */

.activeNavIcons{
  

color:#00A465;
}
.activeNavIcons_link{
  padding: 8px 10px;
  background: aliceblue;
  border-radius: 6px ;
}

.inactiveNavIcons_link{
  padding: 8px 10px;
  /* background: aliceblue; */
  border-radius: 6px ;
}

.inactiveNavIcons{
 
 color: #808080;
}

.shadow_form{
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.form_sidebar{
  width: 274px;
  height: 565px;
  /* background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%); */
  background-color: #F5F5F5;
}

.bg_kyc{
  background-image: linear-gradient(to right, rgba(250,252,254,1), rgba(217,237,237,1))
}



.react-pdf__Page__canvas{
  width: 100% !important ;
  height: 420px !important;
}


/* ---------------- Semantic UI --------------- */
.ui.items>.item>.content p{
  margin-top: 10px;
}

.ui.labeled.icon.button, .ui.labeled.icon.buttons .button {

  margin-top: 22px;
}

.ui.items>.item .content img {
 
  width: 80%;
}

.ui.block.header {
  /* background: #f3f4f5; */
  background: none;
  padding: 0.78571429rem 1rem;
  box-shadow: none;
  /* border: 1px solid #d4d4d5; */
  border: none;
  border-radius: 0.28571429rem;
}
.ui.floating.message {
  /* box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 2px 4px 0 rgba(34,36,38,.12), 0 2px 10px 0 rgba(34,36,38,.15); */
  box-shadow: none;

}

.ui .divider{
  display: none;
}

.ui.header>.icon {
  color: #00A465;
}
.ui.header>.icon+.content {
  font-weight: 500;
}
.ui.basic.buttons {
  /* box-shadow: none; */
  border: none;
  border-radius: 0.28571429rem;
}
.ui.items>.item .extra>[class*="right floated"] {
  margin: 0.25rem 0 0.25rem 0.5rem;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

}
.ui.inverted.menu {
  border: 0 solid transparent;
  background: #00A465;
  box-shadow: none;
  width: 5%;
  margin-top: 50px;
  margin-left: 401px;
}

.ui.massive.vertical.menu {
  
  border: none;
}

.ui.message {
background-color: aliceblue;
}
h1.ui.header {
  font-size: 25px;
}
/* ---------------------------------------------- */


/* ------------ Aadhaar Form ---------------- */

.input-file{
  background-color: #f8f9fc;
  border: 1px solid #e2e9f3;
  border-radius: 4px;
  height: 40px;
  width: 500px;
  color: #565A90;
}
.input-file::file-selector-button{
  border: none;
  border-radius: 4px;
  color: white;
  background-color: #595ef1bd;
  border: 1px solid #595ef1bd;
  height: 40px;
  transition: all .25s ease-in;
  cursor: pointer;
}
.input-file::file-selector-button:hover{
  background-color: #fff;
  color: #565A90;
  transition: all .25s ease-in;
}

/* -------- Upload Files --------- */

.dropzone {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; 
  height: 300px;
  border: 2px dashed #fbbd08;
  padding: 2rem;
  border-radius: 20px;
}

.active {
  background-color: #5f5959;
}

button {
  padding: 1rem;
  /* margin: 1rem; */
  font-size: medium;
}


.list-item {
  display: flex;
  padding: 0;
  margin: 8px 0;
  min-width: 300px;
  font-size: 22px;
  background-color: #d4d2d2;
  cursor: grab;
  border-radius: 10px;
}

.list-item > h3 {
  padding: 10px;
  margin: 0;
}

.list-item > span {
  margin-right: 10px;
  font-size: 24px;
  font-weight: bold;
  border-right: 2px solid white;
  padding: 10px;
  padding-right: 16px;
}

.next-position {
  border: 2px solid #34d44f;
  opacity: 0.2;
}

/* ---------- Drop and Drag ------------ */

.form-container {
	
	
	display: flex;
   	justify-content: center;
	align-items: center;
}
.upload-files-container {
	/* background-color: #f7fff7; */
	width: 420px;
	padding: 6px 54px;
	border-radius: 40px;
	display: flex;
   	align-items: center;
   	justify-content: center;
	flex-direction: column;
	/* box-shadow: rgba(0, 0, 0, 0.24) 0px 10px 20px, rgba(0, 0, 0, 0.28) 0px 6px 6px; */
}
.drag-file-area {
	border: 2px dashed #7b2cbf;
	border-radius: 40px;
	margin: 10px 0 15px;
	padding: 30px 50px;
	width: 350px;
	text-align: center;
}
.drag-file-area .upload-icon {
	font-size: 32px;
}
.drag-file-area h3 {
	font-size: 26px;
	margin: 15px 0;
}
.drag-file-area label {
	font-size: 19px;
}
.drag-file-area label .browse-files-text {
	color: #7b2cbf;
	font-weight: bolder;
	cursor: pointer;
}
.browse-files span {
	position: relative;
	top: -25px;
}
.default-file-input {
	opacity: 0;
}
.cannot-upload-message {
	background-color: #ffc6c4;
	font-size: 17px;
	display: flex;
	align-items: center;
	margin: 5px 0;
	padding: 5px 10px 5px 30px;
	border-radius: 5px;
	color: #BB0000;
	display: none;
}
@keyframes fadeIn {
  0% {opacity: 0;}
  100% {opacity: 1;}
}
.cannot-upload-message span, .upload-button-icon {
	padding-right: 10px;
}
.cannot-upload-message span:last-child {
	padding-left: 20px;
	cursor: pointer;
}
.file-block {
	color: #f7fff7;
	background-color: #7b2cbf;
  	transition: all 1s;
	width: 390px;
	position: relative;
	display: none;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin: 10px 0 15px;
	padding: 10px 20px;
	border-radius: 25px;
	cursor: pointer;
}
.file-info {
	display: flex;
	align-items: center;
	font-size: 15px;
}
.file-icon {
	margin-right: 10px;
}
.file-name, .file-size {
	padding: 0 3px;
}
.remove-file-icon {
	cursor: pointer;
}
.progress-bar {
	display: flex;
	position: absolute;
	bottom: 0;
	left: 4.5%;
	width: 0;
	height: 5px;
	border-radius: 25px;
	background-color: #4BB543;
}
.upload-button {
	font-family: 'Montserrat';
	background-color: #7b2cbf;
	color: #f7fff7;
	display: flex;
	align-items: center;
	font-size: 18px;
	border: none;
	border-radius: 20px;
	margin: 10px;
	padding: 7.5px 50px;
	cursor: pointer;
}

p:first-child {
  margin-top: 14px;
}

.Exam_Header_first{
  color: #14AE5C;
font-size: 30px;
font-style: normal;
font-weight: 700;
line-height: normal;

}
.Exam_Header_text{
  color: #595959;
  text-align: justify;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.placeholder\\:\\!text-gray-400::placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity)) !important;
}
.placeholder\\:text-green-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.placeholder\\:text-red-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.before\\:pointer-events-none::before{
  content: var(--tw-content);
  pointer-events: none;
}
.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}
.before\\:left-\\[50\\%\\]::before{
  content: var(--tw-content);
  left: 50%;
}
.before\\:top-\\[3px\\]::before{
  content: var(--tw-content);
  top: 3px;
}
.before\\:top-\\[50\\%\\]::before{
  content: var(--tw-content);
  top: 50%;
}
.before\\:h-3::before{
  content: var(--tw-content);
  height: 0.75rem;
}
.before\\:h-4::before{
  content: var(--tw-content);
  height: 1rem;
}
.before\\:h-\\[0\\.875rem\\]::before{
  content: var(--tw-content);
  height: 0.875rem;
}
.before\\:w-3::before{
  content: var(--tw-content);
  width: 0.75rem;
}
.before\\:w-4::before{
  content: var(--tw-content);
  width: 1rem;
}
.before\\:w-\\[0\\.875rem\\]::before{
  content: var(--tw-content);
  width: 0.875rem;
}
.before\\:translate-x-\\[-50\\%\\]::before{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:translate-x-\\[2px\\]::before{
  content: var(--tw-content);
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:translate-y-\\[-50\\%\\]::before{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:scale-0::before{
  content: var(--tw-content);
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:rounded-\\[20px\\]::before{
  content: var(--tw-content);
  border-radius: 20px;
}
.before\\:rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:bg-transparent::before{
  content: var(--tw-content);
  background-color: transparent;
}
.before\\:bg-white::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.before\\:opacity-0::before{
  content: var(--tw-content);
  opacity: 0;
}
.before\\:shadow-\\[0_2px_5px_rgba\\(0\\2c _0\\2c _0\\2c _\\.2\\)\\]::before{
  content: var(--tw-content);
  --tw-shadow: 0 2px 5px rgba(0, 0, 0, .2);
  --tw-shadow-colored: 0 2px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.before\\:shadow-\\[0px_0px_0px_13px_transparent\\]::before{
  content: var(--tw-content);
  --tw-shadow: 0px 0px 0px 13px transparent;
  --tw-shadow-colored: 0px 0px 0px 13px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.before\\:transition::before{
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.before\\:transition-all::before{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.before\\:duration-\\[0\\.2s\\]::before{
  content: var(--tw-content);
  transition-duration: 0.2s;
}
.before\\:content-\\[\\"\\"\\]::before{
  --tw-content: "";
  content: var(--tw-content);
}
.before\\:content-\\[\\'\\'\\]::before{
  --tw-content: '';
  content: var(--tw-content);
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:left-\\[2px\\]::after{
  content: var(--tw-content);
  left: 2px;
}
.after\\:top-\\[2px\\]::after{
  content: var(--tw-content);
  top: 2px;
}
.after\\:h-5::after{
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:w-5::after{
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:rounded-full::after{
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:border::after{
  content: var(--tw-content);
  border-width: 1px;
}
.after\\:border-gray-300::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.after\\:bg-white::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.after\\:transition-all::after{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:content-\\[\\'\\'\\]::after{
  --tw-content: '';
  content: var(--tw-content);
}
.checked\\:border-none:checked{
  border-style: none;
}
.checked\\:\\!border-amber-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 158 11 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-blue-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(59 130 246 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-cyan-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(6 182 212 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-gray-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(107 114 128 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-green-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(34 197 94 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-indigo-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(99 102 241 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-lime-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(132 204 22 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-orange-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(249 115 22 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-pink-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(236 72 153 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-purple-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(168 85 247 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-red-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-teal-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(20 184 166 / var(--tw-border-opacity)) !important;
}
.checked\\:\\!border-yellow-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(234 179 8 / var(--tw-border-opacity)) !important;
}
.checked\\:bg-amber-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.checked\\:bg-blue-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.checked\\:bg-cyan-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
.checked\\:bg-gray-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.checked\\:bg-green-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.checked\\:bg-indigo-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}
.checked\\:bg-lime-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity));
}
.checked\\:bg-orange-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.checked\\:bg-pink-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity));
}
.checked\\:bg-purple-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.checked\\:bg-red-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.checked\\:bg-teal-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity));
}
.checked\\:bg-yellow-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
.checked\\:text-white:checked{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.checked\\:before\\:translate-x-\\[22px\\]:checked::before{
  content: var(--tw-content);
  --tw-translate-x: 22px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.checked\\:before\\:\\!bg-amber-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-blue-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-cyan-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-gray-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-green-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-indigo-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-lime-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-orange-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-pink-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-purple-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-red-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-teal-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:\\!bg-yellow-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity)) !important;
}
.checked\\:before\\:opacity-\\[0\\.16\\]:checked::before{
  content: var(--tw-content);
  opacity: 0.16;
}
.checked\\:after\\:absolute:checked::after{
  content: var(--tw-content);
  position: absolute;
}
.checked\\:after\\:-mt-px:checked::after{
  content: var(--tw-content);
  margin-top: -1px;
}
.checked\\:after\\:ml-\\[0\\.25rem\\]:checked::after{
  content: var(--tw-content);
  margin-left: 0.25rem;
}
.checked\\:after\\:block:checked::after{
  content: var(--tw-content);
  display: block;
}
.checked\\:after\\:h-\\[0\\.8125rem\\]:checked::after{
  content: var(--tw-content);
  height: 0.8125rem;
}
.checked\\:after\\:w-\\[0\\.375rem\\]:checked::after{
  content: var(--tw-content);
  width: 0.375rem;
}
.checked\\:after\\:rotate-45:checked::after{
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.checked\\:after\\:border-\\[0\\.125rem\\]:checked::after{
  content: var(--tw-content);
  border-width: 0.125rem;
}
.checked\\:after\\:border-l-0:checked::after{
  content: var(--tw-content);
  border-left-width: 0px;
}
.checked\\:after\\:border-t-0:checked::after{
  content: var(--tw-content);
  border-top-width: 0px;
}
.checked\\:after\\:border-solid:checked::after{
  content: var(--tw-content);
  border-style: solid;
}
.checked\\:after\\:border-white:checked::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.checked\\:after\\:bg-transparent:checked::after{
  content: var(--tw-content);
  background-color: transparent;
}
.checked\\:after\\:content-\\[\\'\\'\\]:checked::after{
  --tw-content: '';
  content: var(--tw-content);
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:cursor-pointer:hover{
  cursor: pointer;
}
.hover\\:border-\\[\\#02295a\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(2 41 90 / var(--tw-border-opacity));
}
.hover\\:border-\\[\\#473dff\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(71 61 255 / var(--tw-border-opacity));
}
.hover\\:bg-black:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.hover\\:bg-gradient-to-b:hover{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.hover\\:bg-none:hover{
  background-image: none;
}
.hover\\:from-white\\/40:hover{
  --tw-gradient-from: rgb(255 255 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:to-white\\/5:hover{
  --tw-gradient-to: rgb(255 255 255 / 0.05) var(--tw-gradient-to-position);
}
.hover\\:font-medium:hover{
  font-weight: 500;
}
.hover\\:text-\\[\\#02295a\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(2 41 90 / var(--tw-text-opacity));
}
.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.hover\\:text-blue-500:hover{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:shadow-\\[0_8px_9px_-4px_rgba\\(59\\2c 113\\2c 202\\2c 0\\.3\\)\\2c 0_4px_18px_0_rgba\\(59\\2c 113\\2c 202\\2c 0\\.2\\)\\]:hover{
  --tw-shadow: 0 8px 9px -4px rgba(59,113,202,0.3),0 4px 18px 0 rgba(59,113,202,0.2);
  --tw-shadow-colored: 0 8px 9px -4px var(--tw-shadow-color), 0 4px 18px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:grayscale-0:hover{
  --tw-grayscale: grayscale(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:before\\:opacity-\\[0\\.04\\]:hover::before{
  content: var(--tw-content);
  opacity: 0.04;
}
.hover\\:before\\:shadow-\\[0px_0px_0px_13px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.6\\)\\]:hover::before{
  content: var(--tw-content);
  --tw-shadow: 0px 0px 0px 13px rgba(0,0,0,0.6);
  --tw-shadow-colored: 0px 0px 0px 13px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-white:focus{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.focus\\:bg-violet-700:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity));
}
.focus\\:shadow-\\[0_8px_9px_-4px_rgba\\(59\\2c 113\\2c 202\\2c 0\\.3\\)\\2c 0_4px_18px_0_rgba\\(59\\2c 113\\2c 202\\2c 0\\.2\\)\\]:focus{
  --tw-shadow: 0 8px 9px -4px rgba(59,113,202,0.3),0 4px 18px 0 rgba(59,113,202,0.2);
  --tw-shadow-colored: 0 8px 9px -4px var(--tw-shadow-color), 0 4px 18px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-none:focus{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#bfe2fd\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 226 253 / var(--tw-ring-opacity));
}
.focus\\:ring-gray-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity));
}
.focus\\:transition-\\[border-color_0\\.2s\\]:focus{
  transition-property: border-color 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.focus\\:placeholder\\:opacity-100:focus::placeholder{
  opacity: 1;
}
.focus\\:before\\:scale-100:focus::before{
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.focus\\:before\\:opacity-\\[0\\.12\\]:focus::before{
  content: var(--tw-content);
  opacity: 0.12;
}
.focus\\:before\\:shadow-\\[0px_0px_0px_13px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.6\\)\\]:focus::before{
  content: var(--tw-content);
  --tw-shadow: 0px 0px 0px 13px rgba(0,0,0,0.6);
  --tw-shadow-colored: 0px 0px 0px 13px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:before\\:transition-\\[box-shadow_0\\.2s\\2c transform_0\\.2s\\]:focus::before{
  content: var(--tw-content);
  transition-property: box-shadow 0.2s,transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.focus\\:after\\:absolute:focus::after{
  content: var(--tw-content);
  position: absolute;
}
.focus\\:after\\:z-\\[1\\]:focus::after{
  content: var(--tw-content);
  z-index: 1;
}
.focus\\:after\\:block:focus::after{
  content: var(--tw-content);
  display: block;
}
.focus\\:after\\:h-\\[0\\.875rem\\]:focus::after{
  content: var(--tw-content);
  height: 0.875rem;
}
.focus\\:after\\:w-\\[0\\.875rem\\]:focus::after{
  content: var(--tw-content);
  width: 0.875rem;
}
.focus\\:after\\:rounded-\\[0\\.125rem\\]:focus::after{
  content: var(--tw-content);
  border-radius: 0.125rem;
}
.focus\\:after\\:content-\\[\\'\\'\\]:focus::after{
  --tw-content: '';
  content: var(--tw-content);
}
.checked\\:focus\\:before\\:scale-100:focus:checked::before{
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.checked\\:focus\\:before\\:shadow-\\[0px_0px_0px_13px_\\#3b71ca\\]:focus:checked::before{
  content: var(--tw-content);
  --tw-shadow: 0px 0px 0px 13px #3b71ca;
  --tw-shadow-colored: 0px 0px 0px 13px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.checked\\:focus\\:before\\:transition-\\[box-shadow_0\\.2s\\2c transform_0\\.2s\\]:focus:checked::before{
  content: var(--tw-content);
  transition-property: box-shadow 0.2s,transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.checked\\:focus\\:after\\:-mt-px:focus:checked::after{
  content: var(--tw-content);
  margin-top: -1px;
}
.checked\\:focus\\:after\\:ml-\\[0\\.25rem\\]:focus:checked::after{
  content: var(--tw-content);
  margin-left: 0.25rem;
}
.checked\\:focus\\:after\\:h-\\[0\\.8125rem\\]:focus:checked::after{
  content: var(--tw-content);
  height: 0.8125rem;
}
.checked\\:focus\\:after\\:w-\\[0\\.375rem\\]:focus:checked::after{
  content: var(--tw-content);
  width: 0.375rem;
}
.checked\\:focus\\:after\\:rotate-45:focus:checked::after{
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.checked\\:focus\\:after\\:rounded-none:focus:checked::after{
  content: var(--tw-content);
  border-radius: 0px;
}
.checked\\:focus\\:after\\:border-\\[0\\.125rem\\]:focus:checked::after{
  content: var(--tw-content);
  border-width: 0.125rem;
}
.checked\\:focus\\:after\\:border-l-0:focus:checked::after{
  content: var(--tw-content);
  border-left-width: 0px;
}
.checked\\:focus\\:after\\:border-t-0:focus:checked::after{
  content: var(--tw-content);
  border-top-width: 0px;
}
.checked\\:focus\\:after\\:border-solid:focus:checked::after{
  content: var(--tw-content);
  border-style: solid;
}
.checked\\:focus\\:after\\:border-white:focus:checked::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.checked\\:focus\\:after\\:bg-transparent:focus:checked::after{
  content: var(--tw-content);
  background-color: transparent;
}
.active\\:bg-gray-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.active\\:bg-none:active{
  background-image: none;
}
.active\\:shadow-\\[0_8px_9px_-4px_rgba\\(59\\2c 113\\2c 202\\2c 0\\.3\\)\\2c 0_4px_18px_0_rgba\\(59\\2c 113\\2c 202\\2c 0\\.2\\)\\]:active{
  --tw-shadow: 0 8px 9px -4px rgba(59,113,202,0.3),0 4px 18px 0 rgba(59,113,202,0.2);
  --tw-shadow-colored: 0 8px 9px -4px var(--tw-shadow-color), 0 4px 18px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group:hover .group-hover\\:bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.group:hover .group-hover\\:bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
.group:hover .group-hover\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.peer:checked ~ .peer-checked\\:bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after{
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:after\\:border-white::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:-translate-y-\\[0\\.9rem\\]{
  --tw-translate-y: -0.9rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:focus ~ .peer-focus\\:scale-\\[0\\.8\\]{
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:focus ~ .peer-focus\\:outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.data-\\[te-input-state-active\\]\\:placeholder\\:opacity-100[data-te-input-state-active]::placeholder{
  opacity: 1;
}
.peer[data-te-input-state-active] ~ .peer-data-\\[te-input-state-active\\]\\:-translate-y-\\[0\\.9rem\\]{
  --tw-translate-y: -0.9rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer[data-te-input-state-active] ~ .peer-data-\\[te-input-state-active\\]\\:scale-\\[0\\.8\\]{
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
:is([dir="rtl"] .rtl\\:space-x-reverse) > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 1;
}
@media (prefers-reduced-motion: reduce){
  .motion-reduce\\:transition-none{
    transition-property: none;
  }
}
@media (prefers-color-scheme: dark){
  .dark\\:\\!border-gray-800{
    --tw-border-opacity: 1 !important;
    border-color: rgb(31 41 55 / var(--tw-border-opacity)) !important;
  }
  .dark\\:\\!border-green-400{
    --tw-border-opacity: 1 !important;
    border-color: rgb(74 222 128 / var(--tw-border-opacity)) !important;
  }
  .dark\\:\\!border-red-400{
    --tw-border-opacity: 1 !important;
    border-color: rgb(248 113 113 / var(--tw-border-opacity)) !important;
  }
  .dark\\:\\!border-white\\/10{
    border-color: rgb(255 255 255 / 0.1) !important;
  }
  .dark\\:border-gray-600{
    --tw-border-opacity: 1;
    border-color: rgb(75 85 99 / var(--tw-border-opacity));
  }
  .dark\\:border-gray-700{
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity));
  }
  .dark\\:border-neutral-600{
    --tw-border-opacity: 1;
    border-color: rgb(82 82 82 / var(--tw-border-opacity));
  }
  .dark\\:border-white\\/10{
    border-color: rgb(255 255 255 / 0.1);
  }
  .dark\\:\\!bg-white{
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:\\!bg-white\\/5{
    background-color: rgb(255 255 255 / 0.05) !important;
  }
  .dark\\:bg-\\[\\#0b14374d\\]{
    background-color: #0b14374d;
  }
  .dark\\:bg-amber-400{
    --tw-bg-opacity: 1;
    background-color: rgb(251 191 36 / var(--tw-bg-opacity));
  }
  .dark\\:bg-blue-400{
    --tw-bg-opacity: 1;
    background-color: rgb(96 165 250 / var(--tw-bg-opacity));
  }
  .dark\\:bg-cyan-400{
    --tw-bg-opacity: 1;
    background-color: rgb(34 211 238 / var(--tw-bg-opacity));
  }
  .dark\\:bg-gray-400{
    --tw-bg-opacity: 1;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity));
  }
  .dark\\:bg-gray-800{
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity));
  }
  .dark\\:bg-gray-900{
    --tw-bg-opacity: 1;
    background-color: rgb(17 24 39 / var(--tw-bg-opacity));
  }
  .dark\\:bg-green-400{
    --tw-bg-opacity: 1;
    background-color: rgb(74 222 128 / var(--tw-bg-opacity));
  }
  .dark\\:bg-indigo-100{
    --tw-bg-opacity: 1;
    background-color: rgb(224 231 255 / var(--tw-bg-opacity));
  }
  .dark\\:bg-indigo-400{
    --tw-bg-opacity: 1;
    background-color: rgb(129 140 248 / var(--tw-bg-opacity));
  }
  .dark\\:bg-lime-400{
    --tw-bg-opacity: 1;
    background-color: rgb(163 230 53 / var(--tw-bg-opacity));
  }
  .dark\\:bg-neutral-700{
    --tw-bg-opacity: 1;
    background-color: rgb(64 64 64 / var(--tw-bg-opacity));
  }
  .dark\\:bg-orange-400{
    --tw-bg-opacity: 1;
    background-color: rgb(251 146 60 / var(--tw-bg-opacity));
  }
  .dark\\:bg-pink-400{
    --tw-bg-opacity: 1;
    background-color: rgb(244 114 182 / var(--tw-bg-opacity));
  }
  .dark\\:bg-purple-400{
    --tw-bg-opacity: 1;
    background-color: rgb(192 132 252 / var(--tw-bg-opacity));
  }
  .dark\\:bg-red-400{
    --tw-bg-opacity: 1;
    background-color: rgb(248 113 113 / var(--tw-bg-opacity));
  }
  .dark\\:bg-teal-400{
    --tw-bg-opacity: 1;
    background-color: rgb(45 212 191 / var(--tw-bg-opacity));
  }
  .dark\\:bg-white\\/10{
    background-color: rgb(255 255 255 / 0.1);
  }
  .dark\\:bg-white\\/20{
    background-color: rgb(255 255 255 / 0.2);
  }
  .dark\\:bg-white\\/30{
    background-color: rgb(255 255 255 / 0.3);
  }
  .dark\\:bg-white\\/5{
    background-color: rgb(255 255 255 / 0.05);
  }
  .dark\\:bg-yellow-400{
    --tw-bg-opacity: 1;
    background-color: rgb(250 204 21 / var(--tw-bg-opacity));
  }
  .dark\\:\\!text-green-400{
    --tw-text-opacity: 1 !important;
    color: rgb(74 222 128 / var(--tw-text-opacity)) !important;
  }
  .dark\\:\\!text-red-400{
    --tw-text-opacity: 1 !important;
    color: rgb(248 113 113 / var(--tw-text-opacity)) !important;
  }
  .dark\\:text-gray-400{
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
  }
  .dark\\:text-neutral-200{
    --tw-text-opacity: 1;
    color: rgb(229 229 229 / var(--tw-text-opacity));
  }
  .dark\\:text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
  .dark\\:shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .dark\\:placeholder\\:\\!text-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.15\\)\\]::placeholder{
    color: rgba(255,255,255,0.15) !important;
  }
  .dark\\:placeholder\\:\\!text-green-400::placeholder{
    --tw-text-opacity: 1 !important;
    color: rgb(74 222 128 / var(--tw-text-opacity)) !important;
  }
  .dark\\:placeholder\\:\\!text-red-400::placeholder{
    --tw-text-opacity: 1 !important;
    color: rgb(248 113 113 / var(--tw-text-opacity)) !important;
  }
  .dark\\:placeholder\\:\\!text-white::placeholder{
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
  }
  .dark\\:placeholder\\:text-neutral-200::placeholder{
    --tw-text-opacity: 1;
    color: rgb(229 229 229 / var(--tw-text-opacity));
  }
  .dark\\:checked\\:\\!border-amber-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(251 191 36 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-blue-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(96 165 250 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-cyan-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(34 211 238 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-gray-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(156 163 175 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-green-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(74 222 128 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-indigo-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(129 140 248 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-lime-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(163 230 53 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-orange-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(251 146 60 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-pink-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(244 114 182 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-purple-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(192 132 252 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-red-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(248 113 113 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-teal-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(45 212 191 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:\\!border-yellow-400:checked{
    --tw-border-opacity: 1 !important;
    border-color: rgb(250 204 21 / var(--tw-border-opacity)) !important;
  }
  .dark\\:checked\\:bg-amber-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(251 191 36 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-blue-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(96 165 250 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-cyan-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(34 211 238 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-gray-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-green-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(74 222 128 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-indigo-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(129 140 248 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-lime-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(163 230 53 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-orange-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(251 146 60 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-pink-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(244 114 182 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-purple-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(192 132 252 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-red-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(248 113 113 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-teal-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(45 212 191 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:bg-yellow-400:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(250 204 21 / var(--tw-bg-opacity));
  }
  .dark\\:checked\\:before\\:\\!bg-amber-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(251 191 36 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-blue-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(96 165 250 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-cyan-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(34 211 238 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-gray-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-green-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(74 222 128 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-indigo-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(129 140 248 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-lime-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(163 230 53 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-orange-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(251 146 60 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-pink-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(244 114 182 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-purple-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(192 132 252 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-red-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(248 113 113 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-teal-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(45 212 191 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:checked\\:before\\:\\!bg-yellow-400:checked::before{
    content: var(--tw-content);
    --tw-bg-opacity: 1 !important;
    background-color: rgb(250 204 21 / var(--tw-bg-opacity)) !important;
  }
  .dark\\:hover\\:bg-gray-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }
  .dark\\:hover\\:bg-white\\/20:hover{
    background-color: rgb(255 255 255 / 0.2);
  }
  .dark\\:hover\\:text-white:hover{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
  .hover\\:dark\\:text-white:hover{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
  .dark\\:hover\\:opacity-90:hover{
    opacity: 0.9;
  }
  .dark\\:focus\\:ring-gray-600:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity));
  }
  .dark\\:active\\:bg-white\\/10:active{
    background-color: rgb(255 255 255 / 0.1);
  }
  .dark\\:active\\:opacity-80:active{
    opacity: 0.8;
  }
  .dark\\:active\\:opacity-90:active{
    opacity: 0.9;
  }
  .peer:focus ~ .dark\\:peer-focus\\:text-neutral-200{
    --tw-text-opacity: 1;
    color: rgb(229 229 229 / var(--tw-text-opacity));
  }
}
@media (min-width: 640px){
  .sm\\:\\!mb-0{
    margin-bottom: 0px !important;
  }
  .sm\\:w-\\[460px\\]{
    width: 460px;
  }
  .sm\\:w-fit{
    width: -moz-fit-content;
    width: fit-content;
  }
  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }
  .sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }
  .sm\\:overflow-auto{
    overflow: auto;
  }
  .sm\\:overflow-x-auto{
    overflow-x: auto;
  }
  .sm\\:text-\\[14px\\]{
    font-size: 14px;
  }
}
@media (min-width: 768px){
  .md\\:static{
    position: static;
  }
  .md\\:-start-\\[330px\\]{
    inset-inline-start: -330px;
  }
  .md\\:-start-\\[440px\\]{
    inset-inline-start: -440px;
  }
  .md\\:\\!z-50{
    z-index: 50 !important;
  }
  .md\\:mb-0{
    margin-bottom: 0px;
  }
  .md\\:mb-10{
    margin-bottom: 2.5rem;
  }
  .md\\:mr-0{
    margin-right: 0px;
  }
  .md\\:mt-0{
    margin-top: 0px;
  }
  .md\\:mt-16{
    margin-top: 4rem;
  }
  .md\\:mt-2{
    margin-top: 0.5rem;
  }
  .md\\:block{
    display: block;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:w-8\\/12{
    width: 66.666667%;
  }
  .md\\:w-9\\/12{
    width: 75%;
  }
  .md\\:w-\\[365px\\]{
    width: 365px;
  }
  .md\\:w-auto{
    width: auto;
  }
  .md\\:shrink-0{
    flex-shrink: 0;
  }
  .md\\:flex-grow-0{
    flex-grow: 0;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:flex-col{
    flex-direction: column;
  }
  .md\\:items-start{
    align-items: flex-start;
  }
  .md\\:justify-between{
    justify-content: space-between;
  }
  .md\\:\\!gap-14{
    gap: 3.5rem !important;
  }
  .md\\:gap-1{
    gap: 0.25rem;
  }
  .md\\:space-x-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0px * var(--tw-space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-x-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(10rem * var(--tw-space-x-reverse));
    margin-left: calc(10rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-x-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-y-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
  }
  .md\\:border-0{
    border-width: 0px;
  }
  .md\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }
  .md\\:p-0{
    padding: 0px;
  }
  .md\\:p-3{
    padding: 0.75rem;
  }
  .md\\:\\!px-0{
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .md\\:pl-6{
    padding-left: 1.5rem;
  }
  .md\\:pt-8{
    padding-top: 2rem;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  @media (prefers-color-scheme: dark){
    .md\\:dark\\:bg-gray-900{
      --tw-bg-opacity: 1;
      background-color: rgb(17 24 39 / var(--tw-bg-opacity));
    }
  }
}
@media (min-width: 1024px){
  .lg\\:\\!z-50{
    z-index: 50 !important;
  }
  .lg\\:mb-0{
    margin-bottom: 0px;
  }
  .lg\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .lg\\:mt-0{
    margin-top: 0px;
  }
  .lg\\:w-5\\/12{
    width: 41.666667%;
  }
  .lg\\:w-6\\/12{
    width: 50%;
  }
  .lg\\:max-w-\\[100\\%\\]{
    max-width: 100%;
  }
  .lg\\:max-w-\\[65\\%\\]{
    max-width: 65%;
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:flex-nowrap{
    flex-wrap: nowrap;
  }
  .lg\\:justify-between{
    justify-content: space-between;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:pb-0{
    padding-bottom: 0px;
  }
  .lg\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 1280px){
  .xl\\:\\!z-0{
    z-index: 0 !important;
  }
  .xl\\:mb-2{
    margin-bottom: 0.5rem;
  }
  .xl\\:hidden{
    display: none;
  }
  .xl\\:h-\\[350px\\]{
    height: 350px;
  }
  .xl\\:w-5\\/12{
    width: 41.666667%;
  }
  .xl\\:w-6\\/12{
    width: 50%;
  }
  .xl\\:w-\\[1310px\\]{
    width: 1310px;
  }
  .xl\\:w-\\[225px\\]{
    width: 225px;
  }
  .xl\\:w-\\[365px\\]{
    width: 365px;
  }
  .xl\\:w-\\[70\\%\\]{
    width: 70%;
  }
  .xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .xl\\:flex-row{
    flex-direction: row;
  }
  .xl\\:flex-col{
    flex-direction: column;
  }
  .xl\\:items-start{
    align-items: flex-start;
  }
  .xl\\:gap-2{
    gap: 0.5rem;
  }
  .xl\\:overflow-hidden{
    overflow: hidden;
  }
  .xl\\:overflow-x-hidden{
    overflow-x: hidden;
  }
  .xl\\:\\!px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  .xl\\:pb-6{
    padding-bottom: 1.5rem;
  }
}
@media (min-width: 1536px){
  .\\32xl\\:col-span-6{
    grid-column: span 6 / span 6;
  }
  .\\32xl\\:mt-\\[150px\\]{
    margin-top: 150px;
  }
  .\\32xl\\:h-\\[70px\\]{
    height: 70px;
  }
  .\\32xl\\:w-\\[240\\]{
    width: 240;
  }
  .\\32xl\\:w-\\[30\\%\\]{
    width: 30%;
  }
  .\\32xl\\:w-\\[80\\%\\]{
    width: 80%;
  }
  .\\32xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .\\32xl\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .\\32xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .\\32xl\\:items-start{
    align-items: flex-start;
  }
  .\\32xl\\:overflow-hidden{
    overflow: hidden;
  }
}
.\\[\\&\\:not\\(\\[data-te-input-placeholder-active\\]\\)\\]\\:placeholder\\:opacity-0:not([data-te-input-placeholder-active])::placeholder{
  opacity: 0;
}
















`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,sEAAsE;AACtE,iEAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;CAAc;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;IAAA,6CAAc;IAAd,wCAAc;IAAd,mCAAc;IAAd,sBAAc;EAAA;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA,WAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,2KAAmB;EAAnB,mKAAmB;EAAnB,4LAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;;AAanB;EACE,gDAA2C;EAC3C,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;;EAEnB,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;;;AAIA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,yDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;CACC,2DAA2D;EAC1D;;sBAEoB;EACpB,qBAAqB;EACrB,sBAAsB;;AAExB;;AAEA;;EAEE,sBAAsB;;AAExB;;;;AAIA;CACC;EACC,iBAAiB;EACjB,gBAAgB;CACjB;CACA;EACC,SAAS;CACV;AACD;AACA;;;GAGG;;AAEH;CACC,kBAAkB;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IAEb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;CAEC,iCAAiC;IAC9B,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;IACV,6FAA6F;IAC7F,yFAAyF;;IAEzF,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IAEb,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IAEb,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;CACnB,iCAAiC;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IAEjB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;;;CAIC;IACG,aAAa;IACb,sBAAsB;IAEtB,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;GACV,iBAAiB;AACpB;;CAEC;IACG,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;AAEtB;;CAEC;IACG,aAAa;IACb,SAAS;AACb;AACA;IACI,yEAAwE;AAC5E;;AAEA;IACI,aAAa;IACb,yEAAwE;IACxE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,oCAAoC;IACpC,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;CACC;EACC,mBAAmB;CACpB;AACD;;AAEA;IACI,WAAW;;IAEX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;;IAErB,eAAe;IACf,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yEAAyE;IACzE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,oCAAoC;IACpC,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;;AAEf;AACA;EACE,WAAW;;AAEb;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;;AAEf;AACA;EACE,WAAW;;AAEb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;CACC;EACC,mBAAmB;CACpB;AACD;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,aAAa;IAEb,mBAAmB;AACvB;;AAEA;;;GAGG;AACH;EACE,WAAW;IACT,aAAa;AACjB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;;;AAGA,oCAAoC;;AAEpC;IACI,aAAa;IACb,YAAY;IACZ,mDAA8D;IAC9D,oBAAoB;;IAEpB,SAAS;AACb;;AAEA;CACC;EACC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;CACjB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,iBAAiB;CAClB;AACD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,kCAAkC;IAClC,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;IAET,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,mCAAmC;IACnC,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;IAET,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,mCAAmC;IACnC,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;IAET,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;;AAGA,gDAAgD;;AAEhD;;;AAGA,aAAa;AACb;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;CAEC,cAAc;AACf;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yEAAyE;EACzE,yBAAyB;AAC3B;;AAEA;EACE;AACF;;;;AAIA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;;AAGA,iDAAiD;AACjD;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,qHAAqH;EACrH,gBAAgB;;AAElB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,2CAA2C;;AAE7C;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;AACA,2BAA2B;AAC3B;AACA;EACE,eAAe;AACjB;AACA,mDAAmD;;;AAGnD,+CAA+C;;AAE/C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EAEZ,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,4BAA4B;AAC9B;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,0CAA0C;;AAI1C;;;CAGC,aAAa;IACV,uBAAuB;CAC1B,mBAAmB;AACpB;AACA;CACC,+BAA+B;CAC/B,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,aAAa;IACV,mBAAmB;IACnB,uBAAuB;CAC1B,sBAAsB;CACtB,oFAAoF;AACrF;AACA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;CACd,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,yBAAyB;CACzB,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,0BAA0B;CAC1B,kBAAkB;CAClB,cAAc;CACd,aAAa;AACd;AACA;EACE,IAAI,UAAU,CAAC;EACf,MAAM,UAAU,CAAC;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,cAAc;CACd,yBAAyB;GACvB,kBAAkB;CACpB,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,QAAQ;CACR,WAAW;CACX,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,YAAY;CACZ,mBAAmB;CACnB,eAAe;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;;AAEnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AA3mCA;EAAA,+BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,qBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,eA4nCA;EA5nCA,eA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,wCA4nCA;EA5nCA,qDA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,yCA4nCA;EA5nCA,4DA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,gKA4nCA;EA5nCA,wJA4nCA;EA5nCA,iLA4nCA;EA5nCA,wDA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,wBA4nCA;EA5nCA,wDA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,gBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,gBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,wBA4nCA;EA5nCA,wDA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,gBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iCA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,gBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iBA4nCA;EA5nCA,iBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA,2EA4nCA;EA5nCA,qEA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA,kFA4nCA;EA5nCA,+FA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,4BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6CA4nCA;EA5nCA,4DA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kFA4nCA;EA5nCA,+FA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,sBA4nCA;EA5nCA,8BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,8BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,2GA4nCA;EA5nCA,yGA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,2GA4nCA;EA5nCA,yGA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,sCA4nCA;EA5nCA,wDA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,eA4nCA;EA5nCA,eA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,6CA4nCA;EA5nCA,4DA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,mDA4nCA;EA5nCA,wDA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,gBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,eA4nCA;EA5nCA,eA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,qCA4nCA;EA5nCA,4DA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,mDA4nCA;EA5nCA,wDA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA,kFA4nCA;EA5nCA,+FA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,oBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,kBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,0BA4nCA;EA5nCA,sBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,yBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iBA4nCA;EA5nCA,iBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,8BA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA,yBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA,iBA4nCA;EA5nCA,iBA4nCA;EA5nCA;AA4nCA;AA5nCA;EAAA;AA4nCA;AA5nCA;EAAA;IAAA;EA4nCA;AAAA;AA5nCA;EAAA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,sBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,sBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,sBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,+BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,+BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,oBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,oBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,oBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,sBA4nCA;IA5nCA,8BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,+BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,+BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,+BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,oBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,iCA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,0BA4nCA;IA5nCA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,oBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,oBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,oBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,oBA4nCA;IA5nCA;EA4nCA;AAAA;AA5nCA;EAAA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,uBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;AAAA;AA5nCA;EAAA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,uBA4nCA;IA5nCA,mDA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,uBA4nCA;IA5nCA,qDA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,uBA4nCA;IA5nCA,oDA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,uBA4nCA;IA5nCA,+DA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,4BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,eA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA,mBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;MAAA,kBA4nCA;MA5nCA;IA4nCA;EAAA;AAAA;AA5nCA;EAAA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,kBA4nCA;IA5nCA;EA4nCA;AAAA;AA5nCA;EAAA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA,6BA4nCA;IA5nCA;EA4nCA;EA5nCA;IAAA;EA4nCA;AAAA;AA5nCA;EAAA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;EA5nCA;IAAA;EA4nCA;AAAA;AA5nCA;EAAA;AA4nCA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap\");\n/* @import url(../../node_modules/semantic-ui-css/semantic.min.css); */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url(../node_modules/semantic-ui-css/semantic.min.css);\n@layer base {\n  html {\n    font-family: \"DM Sans\", sans-serif !important;\n    font-feature-settings: \"kern\" !important;\n    -webkit-font-smoothing: antialiased;\n    letter-spacing: -0.5px;\n  }\n}\n\n\n\ninput.defaultCheckbox::before {\n  content: url(../src/assets/svg/checked.svg);\n  color: white;\n  opacity: 0;\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0px);\n}\n\ninput:checked.defaultCheckbox::before {\n  opacity: 1;\n}\n\n.timeContainer {\n  z-index: 10;\n  display: flex;\n  /* border: 1px solid red; */\n}\n\n.timeContainer .wrapper {\n  width: 100%;\n  /* padding: 20px; */\n\n  display: flex;\n  justify-content: space-around;\n  gap: 10px;\n}\n\n.timeContainer .wrapper div {\n  /* color: #ccc; */\n  text-align: center;\n  width: 24%;\n  height: 50px;\n  border-radius: 12px;\n  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16); */\n}\n\n.timeContainer .wrapper div:first-child {\n  color: #28648a;\n}\n\n.timeContainer .wrapper div:nth-child(2) {\n  color: #28648a;\n}\n\n.timeContainer .wrapper div:nth-child(3) {\n  color: #28648a;\n}\n\n.timeContainer .wrapper div:nth-child(4) {\n  color: #28648a;\n}\n.timeContainer .wrapper div:nth-child(5) {\n  color: #28648a;\n}\n\n\n\n.timeContainer .wrapper div h2 {\n  font-size: 10px;\n}\n\n#seconds {\n  font-size: 16px;\n}\n\n#minutes {\n  font-size: 16px;\n}\n#hours {\n  font-size: 16px;\n}\n\n.hours_text{\n  font-size: 12px;\n}\n\n.backgroundLogin {\n  background-image: linear-gradient(115deg, #9f7aea, #fee2fe);\n  background-size: cover;\n}\n\n.backgroundImg {\n  background-image: url(\"./assets/Icon/background.png\");\n}\n\n#header-bar {\n  background-color: #dfe1e3 !important;\n  display: none;\n}\n#pdf-page-info {\n  display: none;\n}\n#pdf-download {\n  display: none;\n}\n.ui.inverted.menu {\n  background-color: #3970de;\n}\na:hover {\n  color: #3970de;\n  text-decoration: none;\n}\n\n@media only screen and (max-width: 640px) and (min-width: 0px) {\n  .question {\n    font-size: 18px;\n  }\n  .ui.massive.buttons .button {\n    font-size: 18px;\n  }\n\n  .ui[class*=\"right floated\"].button,\n  .ui[class*=\"right floated\"].buttons {\n    float: left;\n    margin-right: 0;\n    margin-left: 0.25em;\n  }\n\n  .ui.items > .item [class*=\"right floated\"] {\n    float: left;\n  }\n\n  .ui.items > .item .extra > [class*=\"right floated\"] {\n    margin: 0;\n  }\n  .ui.huge.message {\n    font-size: 16px;\n  }\n\n  .options {\n    font-size: 16px;\n  }\n\n  .ui.container {\n    width: auto !important;\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n  }\n}\n\n@media only screen and (max-width: 768px) and (min-width: 640px) {\n  .question {\n    font-size: 18px;\n  }\n  .ui.massive.buttons .button {\n    font-size: 18px;\n  }\n  .ui.huge.message {\n    font-size: 16px;\n  }\n  .options {\n    font-size: 16px;\n  }\n}\n\n@media only screen and (max-width: 1024px) and (min-width: 768px) {\n  .question {\n    font-size: 18px;\n  }\n  .ui.massive.buttons .button {\n    font-size: 18px;\n  }\n  .ui.huge.message {\n    font-size: 16px;\n  }\n  .options {\n    font-size: 16px;\n  }\n}\n\n@media only screen and (max-width: 1200px) and (min-width: 1024px) {\n  .question {\n    font-size: 20px;\n  }\n  .ui.massive.buttons .button {\n    font-size: 20px;\n  }\n  .ui.huge.message {\n    font-size: 18px;\n  }\n  .options {\n    font-size: 16px;\n  }\n}\n\n@media only screen and (max-width: 1536px) and (min-width: 1200px) {\n  .question {\n    font-size: 22px;\n  }\n  .ui.massive.buttons .button {\n    font-size: 22px;\n  }\n  .ui.huge.message {\n    font-size: 20px;\n  }\n  .options {\n    font-size: 16px;\n  }\n}\n\n.businessUpdateWrapper {\n\t/* background-image: url(\"./assets/Icon/background.png\"); */\n  background: url(\"./assets/Icon/Home_bg6.png\")\n    no-repeat,\n    rgb(250, 250, 250);\n  padding: 15px 0px 8px;\n  background-size: cover; \n\n}\n\n.businessUpdateWrapper1 {\n\t\n  padding: 15px 0px 64px;\n\n}\n\n\n\n@media (min-width: 768px){\n\t.fkjiCM {\n\t\tmax-width: 1400px;\n\t\tmargin: 0px auto;\n\t}\n\t.fkjiCM .businessUpdateWrapper {\n\t\tgap: 20px;\n\t}\n}\n/* .fkjiCM {\n    max-width: 1400px;\n    margin: 0px auto;\n} */\n\n.fkjiCM .business_update {\n\tfont-family: unset;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 37px;\n    line-height: 50px;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    text-align: center;\n    max-width: 1200px;\n    color: rgb(0, 0, 0);\n    margin: 60px auto 30px;\n    margin-left: 40px;\n}\n\n.ekulFW {\n    \n\tfont-family: 'Roboto', sans-serif;\n    font-style: normal;\n    width: 100%;\n    left: 112px;\n    top: 206px;\n    background: linear-gradient(259.24deg, rgb(241, 226, 204) -10.54%, rgb(251, 236, 237) 97.86%);\n    background: linear-gradient(259.24deg, rgb(126 190 234) -10.54%, rgb(217 233 242) 97.86%);\n\n    border-radius: 12px;\n}\n\n.ekulFW .titleValue {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 50px;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    color: rgb(0, 0, 0);\n    padding: 0px 0px 5px;\n}\n\n.ekulFW .regards {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 32px;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    text-transform: capitalize;\n    color: rgb(0, 0, 0);\n}\n\n.ekulFW .description {\n    font-size: 20px;\n    font-weight: 400;\n    padding: 10px 0px;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    max-width: 84%;\n}\n\n.ekulFW .renewals_redirection {\n    margin: 10px 0px;\n    background: #fff;\n\tfont-family: 'Roboto', sans-serif;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 32px;\n    -webkit-box-align: center;\n    align-items: center;\n    padding: 8px 20px;\n    color: rgb(0, 0, 0);\n    border-radius: 12px;\n    cursor: pointer;\n    width: 157px;\n}\n\n.fkjiCM .businessUpdateWrapper {\n    display: flex;\n    padding: 0px 112px;\n}\n.ekulFW .upcomingRenewals {\n    display: flex;\n}\n.ekulFW .left_section {\n    width: 70%;\n    padding: 24px 0px 24px 40px;\n}\n\n.ekulFW .right_section {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n}\n\n\n\n .goalsWrapper {\n    display: flex;\n    flex-direction: column;\n    -webkit-box-align: center;\n    align-items: center;\n    /* padding: 80px 40px 80px; */\n    gap: 36px;\n\t  padding-top: 30px;\n}\n\n .homeHeading {\n    width: 908px;\n    color: rgb(0, 0, 0);\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 50px;\n    text-align: center;\n    \n}\n\n .goalsContent {\n    display: flex;\n    gap: 23px;\n}\n.cNBNFI.active {\n    background: url('./assets//Icon/ActiveGoals2.png') center center / cover;\n}\n\n.cNBNFI {\n    display: flex;\n    background: url('./assets//Icon/ActiveGoals2.png') center center / cover;\n    padding: 20px 32px;\n    width: 390px;\n    border-radius: 12px;\n}\n\n.cNBNFI .goalDescriptionWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.cNBNFI .goalDescriptionWrapper .step {\n    display: flex;\n    color: rgb(18, 22, 23);\n    font-size: 14px;\n    letter-spacing: 0.28px;\n    line-height: 16px;\n    padding: 4px 8px;\n    border-radius: 23px;\n    border: 1px solid rgb(255, 255, 255);\n    background: rgba(255, 255, 255, 0.7);\n    width: fit-content;\n    text-align: center;\n    margin-bottom: 11.5px;\n}\n\n.cNBNFI .goalDescriptionWrapper .title {\n    margin-bottom: 7.5px;\n    color: rgb(18, 22, 23);\n    font-size: 18px;\n    font-weight: 700;\n    letter-spacing: 0.36px;\n    line-height: 21px;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.cNBNFI .goalDescriptionWrapper .description {\n    color: rgb(18, 22, 23);\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.28px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.cNBNFI .goalDescriptionWrapper .actionWrapper {\n    display: flex;\n    align-items: flex-start;\n    padding: 0px !important;\n}\n\n@media (min-width: 768px){\n\t.actionWrapper {\n\t\tflex-direction: row;\n\t}\n}\n\n.cNBNFI .goalDescriptionWrapper .actionWrapper .ctaButton {\n    color: #000;\n\n    font-size: 15px;\n    font-weight: 700;\n    padding: 10px 16px;\n    margin-top: 14px;\n    border-radius: 24px;\n    background: #ffffffb3;\n\n    cursor: pointer;\n    line-height: 17.58px;\n}\n\n.actionWrapper span {\n   \n    display: flex;\n    flex-direction: row;\n}\n\n.cNBNFI {\n    display: flex;\n    background: url('./assets/Icon/InactiveGoals2.png') center center / cover;\n    padding: 20px 32px;\n    width: 390px;\n    border-radius: 12px;\n}\n\n.cNBNFI .goalDescriptionWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.cNBNFI .goalDescriptionWrapper .step {\n    display: flex;\n    color: rgb(18, 22, 23);\n    font-size: 14px;\n    letter-spacing: 0.28px;\n    line-height: 16px;\n    padding: 4px 8px;\n    border-radius: 23px;\n    border: 1px solid rgb(255, 255, 255);\n    background: rgba(255, 255, 255, 0.7);\n    width: fit-content;\n    text-align: center;\n    margin-bottom: 11.5px;\n}\n\n.cNBNFI .goalDescriptionWrapper .title.inactiveTitle {\n    color: #000;\n    \n}\n.cNBNFI .goalDescriptionWrapper .title.activeTitle {\n  color: #fff;\n  \n}\n\n.cNBNFI .goalDescriptionWrapper .title {\n    margin-bottom: 7.5px;\n    color: rgb(18, 22, 23);\n    font-size: 18px;\n    font-weight: 700;\n    letter-spacing: 0.36px;\n    line-height: 21px;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.cNBNFI .goalDescriptionWrapper .description {\n    color: rgb(18, 22, 23);\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.28px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.cNBNFI .goalDescriptionWrapper .description.inactiveDescription {\n    color: #000;\n   \n}\n.cNBNFI .goalDescriptionWrapper .description.activeDescription {\n  color: #fff;\n \n}\n\n.cNBNFI .goalDescriptionWrapper .actionWrapper {\n    display: flex;\n    align-items: flex-start;\n    padding: 0px !important;\n}\n\n@media (min-width: 768px){\n\t.actionWrapper {\n\t\tflex-direction: row;\n\t}\n}\n.cNBNFI .goalDescriptionWrapper .actionWrapper .note {\n    color: rgb(255, 62, 1);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.24px;\n    padding-top: 8px;\n}\n.cNBNFI .iconWrapper {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n/* .cNBNFI .iconWrapper > img {\n    width: 108px;\n    height: 108px;\n} */\n.certi_image{\n  width: 88px;\n    height: 108px;\n}\n.kyc_image{\n  width: 108px;\n  height: 100px;\n}\n.sell_image{\n  width: 108px;\n  height: 108px;\n}\n\n\n/* ------------ What can --------- */\n\n.iUAlfZ .turtlemintSectionWrapper {\n    display: flex;\n    width: 100vw;\n    background: url(\"../src/assets/Icon/turtlemintSectionBg.webp\");\n    padding: 80px 112px ;\n\n    gap: 34px;\n}\n\n@media  (min-width: 768px) {\n\t.iUAlfZ .turtlemintSectionContainer {\n\t\tdisplay: flex;\n\t\tmax-width: 1400px;\n\t\tmargin: 0px auto;\n\t}\n\t.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionContent > div:nth-child(2n+1) {\n\t\tmargin-top: 124px;\n\t}\n\t.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionContent > div:nth-child(2n) {\n\t\tmargin-bottom: 124px;\n\t}\n\t.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionContent > div:nth-child(2n+1) {\n\t\tmargin-top: 124px;\n\t}\n}\n\n.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionTitle {\n    font-size: 40px;\n    font-weight: 400;\n    line-height: 70px;\n    color: rgb(3, 56, 36);\n    width: 314px;\n    padding-top: 29px;\n}\n.iUAlfZ .turtlemintSectionWrapper .turtlemintSectionContent {\n    display: flex;\n    gap: 32px;\n}\n\n.cKgNZQ {\n    display: flex;\n    flex-direction: column;\n    width: 268px;\n    height: 288px;\n    padding: 24px;\n    border-radius: 8px;\n    background: rgb(255, 255, 255);\n    border: 1px solid rgb(0, 164, 101);\n    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 16px 0px;\n}\n\n.cKgNZQ > img {\n    display: flex;\n    width: 54px;\n    height: 54px;\n}\n\n.cKgNZQ .sectionDetailsWrapper {\n    display: flex;\n    flex-direction: column;\n}\n\n.cKgNZQ .sectionDetailsWrapper .title {\n    padding: 16px 0px;\n    color: rgb(48, 55, 51);\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 14px;\n}\n\n.cKgNZQ .sectionDetailsWrapper .description {\n    font-size: 14px;\n    line-height: 24px;\n    color: rgb(96, 96, 96);\n}\n\n.cKgNZQ .sectionDetailsWrapper .ctaWrapper {\n    display: flex;\n    cursor: pointer;\n    padding: 40px 0px 0px;\n    gap: 16px;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n.cKgNZQ .sectionDetailsWrapper .ctaWrapper .cta {\n    color: rgb(0, 134, 115);\n    font-size: 17px;\n    font-weight: 700;\n}\n\n.xineh {\n    display: flex;\n    flex-direction: column;\n    width: 268px;\n    height: 288px;\n    padding: 24px;\n    border-radius: 8px;\n    background: rgb(255, 255, 255);\n    border: 1px solid rgb(245, 174, 10);\n    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 16px 0px;\n}\n\n.xineh > img {\n    display: flex;\n    width: 54px;\n    height: 54px;\n}\n\n.xineh .sectionDetailsWrapper {\n    display: flex;\n    flex-direction: column;\n}\n\n.xineh .sectionDetailsWrapper .title {\n    padding: 16px 0px;\n    color: rgb(48, 55, 51);\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 14px;\n}\n\n.xineh .sectionDetailsWrapper .description {\n    font-size: 14px;\n    line-height: 24px;\n    color: rgb(96, 96, 96);\n}\n\n.xineh .sectionDetailsWrapper .ctaWrapper {\n    display: flex;\n    cursor: pointer;\n    padding: 40px 0px 0px;\n    gap: 16px;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n.xineh .sectionDetailsWrapper .ctaWrapper .cta {\n    color: rgb(245, 174, 10);\n    font-size: 17px;\n    font-weight: 700;\n}\n\n.xineh .sectionDetailsWrapper .ctaWrapper > svg > circle {\n    fill: rgb(245, 174, 10);\n    stroke: rgb(253, 239, 206);\n}\n\n.hkRHto {\n    display: flex;\n    flex-direction: column;\n    width: 268px;\n    height: 288px;\n    padding: 24px;\n    border-radius: 8px;\n    background: rgb(255, 255, 255);\n    border: 1px solid rgb(171, 37, 108);\n    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 16px 0px;\n}\n\n.hkRHto > img {\n    display: flex;\n    width: 54px;\n    height: 54px;\n}\n.hkRHto .sectionDetailsWrapper {\n    display: flex;\n    flex-direction: column;\n}\n\n.hkRHto .sectionDetailsWrapper .title {\n    padding: 16px 0px;\n    color: rgb(48, 55, 51);\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 14px;\n}\n\n.hkRHto .sectionDetailsWrapper .description {\n    font-size: 14px;\n    line-height: 24px;\n    color: rgb(96, 96, 96);\n}\n\n.hkRHto .sectionDetailsWrapper .ctaWrapper {\n    display: flex;\n    cursor: pointer;\n    padding: 40px 0px 0px;\n    gap: 16px;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n.hkRHto .sectionDetailsWrapper .ctaWrapper > svg > circle {\n    fill: rgb(171, 37, 108);\n    stroke: rgb(239, 201, 220);\n}\n\n\n/* ------- Navbar Icons Color ---------------- */\n\n.activeNavIcons{\n  \n\ncolor:#00A465;\n}\n.activeNavIcons_link{\n  padding: 8px 10px;\n  background: aliceblue;\n  border-radius: 6px ;\n}\n\n.inactiveNavIcons_link{\n  padding: 8px 10px;\n  /* background: aliceblue; */\n  border-radius: 6px ;\n}\n\n.inactiveNavIcons{\n \n color: #808080;\n}\n\n.shadow_form{\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n\n.form_sidebar{\n  width: 274px;\n  height: 565px;\n  /* background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%); */\n  background-color: #F5F5F5;\n}\n\n.bg_kyc{\n  background-image: linear-gradient(to right, rgba(250,252,254,1), rgba(217,237,237,1))\n}\n\n\n\n.react-pdf__Page__canvas{\n  width: 100% !important ;\n  height: 420px !important;\n}\n\n\n/* ---------------- Semantic UI --------------- */\n.ui.items>.item>.content p{\n  margin-top: 10px;\n}\n\n.ui.labeled.icon.button, .ui.labeled.icon.buttons .button {\n\n  margin-top: 22px;\n}\n\n.ui.items>.item .content img {\n \n  width: 80%;\n}\n\n.ui.block.header {\n  /* background: #f3f4f5; */\n  background: none;\n  padding: 0.78571429rem 1rem;\n  box-shadow: none;\n  /* border: 1px solid #d4d4d5; */\n  border: none;\n  border-radius: 0.28571429rem;\n}\n.ui.floating.message {\n  /* box-shadow: 0 0 0 1px rgba(34,36,38,.22) inset, 0 2px 4px 0 rgba(34,36,38,.12), 0 2px 10px 0 rgba(34,36,38,.15); */\n  box-shadow: none;\n\n}\n\n.ui .divider{\n  display: none;\n}\n\n.ui.header>.icon {\n  color: #00A465;\n}\n.ui.header>.icon+.content {\n  font-weight: 500;\n}\n.ui.basic.buttons {\n  /* box-shadow: none; */\n  border: none;\n  border-radius: 0.28571429rem;\n}\n.ui.items>.item .extra>[class*=\"right floated\"] {\n  margin: 0.25rem 0 0.25rem 0.5rem;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n\n}\n.ui.inverted.menu {\n  border: 0 solid transparent;\n  background: #00A465;\n  box-shadow: none;\n  width: 5%;\n  margin-top: 50px;\n  margin-left: 401px;\n}\n\n.ui.massive.vertical.menu {\n  \n  border: none;\n}\n\n.ui.message {\nbackground-color: aliceblue;\n}\nh1.ui.header {\n  font-size: 25px;\n}\n/* ---------------------------------------------- */\n\n\n/* ------------ Aadhaar Form ---------------- */\n\n.input-file{\n  background-color: #f8f9fc;\n  border: 1px solid #e2e9f3;\n  border-radius: 4px;\n  height: 40px;\n  width: 500px;\n  color: #565A90;\n}\n.input-file::file-selector-button{\n  border: none;\n  border-radius: 4px;\n  color: white;\n  background-color: #595ef1bd;\n  border: 1px solid #595ef1bd;\n  height: 40px;\n  cursor: pointer;\n  transition: all .25s ease-in;\n  cursor: pointer;\n}\n.input-file::file-selector-button:hover{\n  background-color: #fff;\n  color: #565A90;\n  transition: all .25s ease-in;\n}\n\n/* -------- Upload Files --------- */\n\n.dropzone {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center; \n  height: 300px;\n  border: 2px dashed #fbbd08;\n  padding: 2rem;\n  border-radius: 20px;\n}\n\n.active {\n  background-color: #5f5959;\n}\n\nbutton {\n  padding: 1rem;\n  /* margin: 1rem; */\n  font-size: medium;\n}\n\n\n.list-item {\n  display: flex;\n  padding: 0;\n  margin: 8px 0;\n  min-width: 300px;\n  font-size: 22px;\n  background-color: #d4d2d2;\n  cursor: grab;\n  border-radius: 10px;\n}\n\n.list-item > h3 {\n  padding: 10px;\n  margin: 0;\n}\n\n.list-item > span {\n  margin-right: 10px;\n  font-size: 24px;\n  font-weight: bold;\n  border-right: 2px solid white;\n  padding: 10px;\n  padding-right: 16px;\n}\n\n.next-position {\n  border: 2px solid #34d44f;\n  opacity: 0.2;\n}\n\n/* ---------- Drop and Drag ------------ */\n\n@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');\n\n.form-container {\n\t\n\t\n\tdisplay: flex;\n   \tjustify-content: center;\n\talign-items: center;\n}\n.upload-files-container {\n\t/* background-color: #f7fff7; */\n\twidth: 420px;\n\tpadding: 6px 54px;\n\tborder-radius: 40px;\n\tdisplay: flex;\n   \talign-items: center;\n   \tjustify-content: center;\n\tflex-direction: column;\n\t/* box-shadow: rgba(0, 0, 0, 0.24) 0px 10px 20px, rgba(0, 0, 0, 0.28) 0px 6px 6px; */\n}\n.drag-file-area {\n\tborder: 2px dashed #7b2cbf;\n\tborder-radius: 40px;\n\tmargin: 10px 0 15px;\n\tpadding: 30px 50px;\n\twidth: 350px;\n\ttext-align: center;\n}\n.drag-file-area .upload-icon {\n\tfont-size: 32px;\n}\n.drag-file-area h3 {\n\tfont-size: 26px;\n\tmargin: 15px 0;\n}\n.drag-file-area label {\n\tfont-size: 19px;\n}\n.drag-file-area label .browse-files-text {\n\tcolor: #7b2cbf;\n\tfont-weight: bolder;\n\tcursor: pointer;\n}\n.browse-files span {\n\tposition: relative;\n\ttop: -25px;\n}\n.default-file-input {\n\topacity: 0;\n}\n.cannot-upload-message {\n\tbackground-color: #ffc6c4;\n\tfont-size: 17px;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 5px 0;\n\tpadding: 5px 10px 5px 30px;\n\tborder-radius: 5px;\n\tcolor: #BB0000;\n\tdisplay: none;\n}\n@keyframes fadeIn {\n  0% {opacity: 0;}\n  100% {opacity: 1;}\n}\n.cannot-upload-message span, .upload-button-icon {\n\tpadding-right: 10px;\n}\n.cannot-upload-message span:last-child {\n\tpadding-left: 20px;\n\tcursor: pointer;\n}\n.file-block {\n\tcolor: #f7fff7;\n\tbackground-color: #7b2cbf;\n  \ttransition: all 1s;\n\twidth: 390px;\n\tposition: relative;\n\tdisplay: none;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin: 10px 0 15px;\n\tpadding: 10px 20px;\n\tborder-radius: 25px;\n\tcursor: pointer;\n}\n.file-info {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 15px;\n}\n.file-icon {\n\tmargin-right: 10px;\n}\n.file-name, .file-size {\n\tpadding: 0 3px;\n}\n.remove-file-icon {\n\tcursor: pointer;\n}\n.progress-bar {\n\tdisplay: flex;\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 4.5%;\n\twidth: 0;\n\theight: 5px;\n\tborder-radius: 25px;\n\tbackground-color: #4BB543;\n}\n.upload-button {\n\tfont-family: 'Montserrat';\n\tbackground-color: #7b2cbf;\n\tcolor: #f7fff7;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 18px;\n\tborder: none;\n\tborder-radius: 20px;\n\tmargin: 10px;\n\tpadding: 7.5px 50px;\n\tcursor: pointer;\n}\n\np:first-child {\n  margin-top: 14px;\n}\n\n.Exam_Header_first{\n  color: #14AE5C;\nfont-size: 30px;\nfont-style: normal;\nfont-weight: 700;\nline-height: normal;\n\n}\n.Exam_Header_text{\n  color: #595959;\n  text-align: justify;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
